import { fetch } from '@/utils/request';

// 优惠券
const couponIndex = (param, callback) => fetch('/shop/coupon/index','GET', param, callback);
const couponInfo = (param, callback) => fetch('/shop/coupon/detail','GET', param, callback);
const couponAdd = (param, callback) => fetch('/shop/coupon/add','POST', param, callback);
const couponEdit = (param, callback) => fetch('/shop/coupon/edit','POST', param, callback);
const couponDel = (param, callback) => fetch('/shop/coupon/del','POST', param, callback);
const couponShenhe = (param, callback) => fetch('/shop/coupon/shenhe','POST', param, callback);
const couponSend = (param, callback) => fetch('/shop/coupon/send','POST', param, callback);
const couponLog = (param, callback) => fetch('/shop/coupon/log','GET', param, callback);
const couponHexiao = (param, callback) => fetch('/shop/coupon/hexiao','POST', param, callback);
const couponSubDel = (param, callback) => fetch('/shop/coupon/sub/del','POST', param, callback);

// 充值
const rechargeIndex = (param, callback) => fetch('/shop/recharge/index','GET', param, callback);
const rechargeInfo = (param, callback) => fetch('/shop/recharge/detail','GET', param, callback);
const rechargeAdd = (param, callback) => fetch('/shop/recharge/add','POST', param, callback);
const rechargeEdit = (param, callback) => fetch('/shop/recharge/edit','POST', param, callback);
const rechargeDel = (param, callback) => fetch('/shop/recharge/del','POST', param, callback);
const rechargeShenhe = (param, callback) => fetch('/shop/recharge/shenhe','POST', param, callback);

// 预售
const presaleIndex = (param, callback) => fetch('/shop/presale/index','GET', param, callback);
const presaleInfo = (param, callback) => fetch('/shop/presale/detail','GET', param, callback);
const presaleAdd = (param, callback) => fetch('/shop/presale/add','POST', param, callback);
const presaleEdit = (param, callback) => fetch('/shop/presale/edit','POST', param, callback);
const presaleDel = (param, callback) => fetch('/shop/presale/del','POST', param, callback);
const presaleShenhe = (param, callback) => fetch('/shop/presale/shenhe','POST', param, callback);

// 新用户有礼
const newUserGiftIndex = (param, callback) => fetch('/shop/new_user_gift/index','GET', param, callback);
const newUserGiftInfo = (param, callback) => fetch('/shop/new_user_gift/detail','GET', param, callback);
const newUserGiftAdd = (param, callback) => fetch('/shop/new_user_gift/add','POST', param, callback);
const newUserGiftEdit = (param, callback) => fetch('/shop/new_user_gift/edit','POST', param, callback);
const newUserGiftDel = (param, callback) => fetch('/shop/new_user_gift/del','POST', param, callback);
const newUserGiftShenhe = (param, callback) => fetch('/shop/new_user_gift/shenhe','POST', param, callback);

// 广告管理
const adIndex = (param, callback) => fetch('/shop/ad/index','GET', param, callback);
const adInfo = (param, callback) => fetch('/shop/ad/detail','GET', param, callback);
const adAdd = (param, callback) => fetch('/shop/ad/add','POST', param, callback);
const adEdit = (param, callback) => fetch('/shop/ad/edit','POST', param, callback);
const adDel = (param, callback) => fetch('/shop/ad/del','POST', param, callback);
const adShenhe = (param, callback) => fetch('/shop/ad/shenhe','POST', param, callback);

// 秒杀
const seckillIndex = (param, callback) => fetch('/shop/seckill/index','GET', param, callback);
const seckillInfo = (param, callback) => fetch('/shop/seckill/detail','GET', param, callback);
const seckillAdd = (param, callback) => fetch('/shop/seckill/add','POST', param, callback);
const seckillEdit = (param, callback) => fetch('/shop/seckill/edit','POST', param, callback);
const seckillDel = (param, callback) => fetch('/shop/seckill/del','POST', param, callback);
const seckillShenhe = (param, callback) => fetch('/shop/seckill/shenhe','POST', param, callback);

// 砍价
const bargainIndex = (param, callback) => fetch('/shop/bargain/index','GET', param, callback);
const bargainInfo = (param, callback) => fetch('/shop/bargain/detail','GET', param, callback);
const bargainAdd = (param, callback) => fetch('/shop/bargain/add','POST', param, callback);
const bargainEdit = (param, callback) => fetch('/shop/bargain/edit','POST', param, callback);
const bargainDel = (param, callback) => fetch('/shop/bargain/del','POST', param, callback);
const bargainShenhe = (param, callback) => fetch('/shop/bargain/shenhe','POST', param, callback);

export default {
  couponIndex,
  couponInfo,
  couponAdd,
  couponEdit,
  couponDel,
  couponShenhe,
  couponSend,
  couponLog,
  couponHexiao,
  couponSubDel,

  rechargeIndex,
  rechargeInfo,
  rechargeAdd,
  rechargeEdit,
  rechargeDel,
  rechargeShenhe,

  presaleIndex,
  presaleInfo,
  presaleAdd,
  presaleEdit,
  presaleDel,
  presaleShenhe,

  newUserGiftIndex,
  newUserGiftInfo,
  newUserGiftAdd,
  newUserGiftEdit,
  newUserGiftDel,
  newUserGiftShenhe,

  adIndex,
  adInfo,
  adAdd,
  adEdit,
  adDel,
  adShenhe,

  seckillIndex,
  seckillInfo,
  seckillAdd,
  seckillEdit,
  seckillDel,
  seckillShenhe,

  bargainIndex,
  bargainInfo,
  bargainAdd,
  bargainEdit,
  bargainDel,
  bargainShenhe
}
